import { css } from 'lit';
export const dinapsisModalSliderPanel = css `
.activated-modal-slider-panel {
  position: fixed;
  z-index: 2000;
  top: 0;
  left:0;
  width: 100%;
  min-height: 100vh;
  overflow: auto;
  background-color: rgba(216, 216, 216, 0.4);
}

.header-container {
  padding: 16px;
  background-color: #e9f4f6;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.title-container {  
  font-family: DinPro-Medium, sans-serif;
  line-height: 1;
  width: 90%;
}

.subtitle-container {    
  font-family: DinPro-Medium, sans-serif;
  width: 100%;
  line-height: 1.2;
}

.material-icons-round {
  font-family: 'Material Icons Round';
  color: #383838;
  display: inline-flex;
  font-size: 24px;
  vertical-align: middle;
}

.title {
  font-size: 18px;
  font-weight: 500;
  color: #383838;
  vertical-align: middle;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 85%;
  display: inline-block;
  height: 20px;
}

.subtitle {
  font-size: 14px;
  font-weight: 500;
  color: #757575;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  line-height: normal;
}

.subtitle__left {
  margin: 5px 0 0 0px;  
}

.subtitle__right {
  margin: 5px 0 0 0px;  
}

.close-icon {
  line-height: 1;
  font-size: 35px; 
  color: #002f6c;
  cursor: pointer;
}

.close-icon:hover {
  color: white;
  background-color: #002f6c;
  border-radius: 50%;
}

.close-icon__right {
  margin-left: -5px;
  margin-right: 10px;
}

.left-panel,
.right-panel {
  position:fixed;
  top:52px;
}

.left-panel-active,
.right-panel-active {
  position:fixed;
  top:52px;
  z-index: 2001;
}
`;
//# sourceMappingURL=dinapsis-modal-slider-panel-style.js.map